import styled, { css, keyframes } from 'styled-components';
import { shade } from 'polished';

import { layout } from '../../../../package.json';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  width: 100%;
  margin: 80px;

  @media (max-width: ${layout.mobile}) {
    width: 90%;
    margin: 5px;

    padding-bottom: 85px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-items: center;

  width: 100%;
  width: 95vw;
`;

const appearFronRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(-450px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  place-content: center;
  width: 100%;
  animation: ${appearFronRight} 1s;

  img {
    width: 470px;
  }

  form {
    margin: 40px 0;
    text-align: center;
    width: 60%;

    a {
      color: #f4ede8;
      display: block;
      margin-top: 24px;
      text-decoration: none;
      transition: color 0.7s;

      &:hover {
        color: ${shade(0.2, '#f4ede8')};
      }
    }

    & + div {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      width: 100%;
      margin: 0;
      margin-bottom: 16px;

      > div {
        margin-left: 16px;
      }
    }
  }

  > a {
    color: #ff9000;
    display: block;
    margin-top: 24px;
    text-decoration: none;
    transition: color 0.2s;

    display: flex;
    align-items: center;

    &:hover {
      color: ${shade(0.2, '#ff9000')};
    }

    svg {
      margin-right: 16px;
    }
  }
`;

export const Title = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 16px;

  color: #000000;
  font-size: 57px;
  font-weight: 600;
  font-style: normal;
  letter-spacing: normal;
  line-height: normal;
  text-align: center;

  span {
    color: #000000;
    margin-left: 16px;
    font-size: 45px;
    font-weight: 700;
    text-align: center;
  }

  p {
    color: #000000;
    font-size: 25px;
    font-weight: 400;
    font-style: normal;
    letter-spacing: normal;
    line-height: 26px;
    text-align: center;
  }

  @media (max-width: ${layout.mobile}) {
    span {
      font-size: 20px;
    }

    p {
      font-size: 18px;
    }
  }
`;

export const ColItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  margin-top: 8px;
`;

interface ButtonProps {
  type: 'track' | 'buying' | 'cancel';
}

export const Button = styled.div<ButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 564px;
  height: 82px;
  border-radius: 50px;
  cursor: pointer;

  ${props =>
    props.type === 'track' &&
    css`
      background-color: #ff6b00;
    `}

  ${props =>
    props.type === 'buying' &&
    css`
      background-color: #32ac3e;
    `}

  ${props =>
    props.type === 'cancel' &&
    css`
      background-color: #ff0000;
    `}

  span {
    color: #ffffff;
    font-size: 21px;
    font-weight: 600;
    font-style: normal;
    letter-spacing: normal;
    line-height: normal;
    text-align: center;
    text-transform: uppercase;
  }

  @media (max-width: ${layout.mobile}) {
    width: 284px;
    height: 62px;

    span {
      font-size: 16px;
    }
  }
`;
